/**
 * Created by hp on 2017/6/9.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {renderMoney} from '../../utils';

import '../../styles/lecture/LectureLimitPrice.css';

class LectureLimitPrice extends Component {
    constructor(props) {
        super(props);

        let limitTimeStamp = this.props.limitMoneyExpireTimestamp;
        let getDuration = () => (limitTimeStamp - parseInt(new Date().getTime() / 1000, 10));
        this.state = {
            duration: getDuration(),
        };

        this.interval = setInterval(() => {
            let duration = getDuration();
            if (duration <= 0) {
                this.props.dispatch({
                    type: 'LECTURE_LIMIT_MONEY_OVER'
                });
            }
            this.setState({duration});
        }, 100);
    }

    componentWillUnmount (){
        clearInterval(this.interval)
    }

    render() {
        let {money, limitMoney} = this.props;
        let tmp = this.state.duration;

        let ss = tmp % 60;
        tmp = (tmp - ss) / 60;

        let mm = tmp % 60;
        tmp = (tmp - mm) / 60;

        let dd = (tmp - tmp % 24) / 24;
        let hh = tmp % 24;

        // 分离小数点
        limitMoney = renderMoney(limitMoney).split(".");
        let moneyMain = limitMoney[0];
        let moneySub = limitMoney[1];

        return (
            <div className="lecture-limit-price">
                <div className="lecture-limit-price__left">
                    <div className="flash-sale-price weui-flex">
                        <span className="flash-sale-num">
                            <span className="flash-sale-num-text">￥</span>
                            <span className="flash-sale-num-main">{moneyMain}</span>
                            <span className="flash-sale-num-point">.</span>
                            <span className="flash-sale-num-sub">
                                {moneySub}
                                <span className="flash-sale-num-sub-text hide">限时特价</span>
                            </span>
                        </span>
                        <div className="weui-flex__item text-left flash-sale-original">
                            <div className="original-cost">￥{renderMoney(money)}</div>
                            <span className="original-tips">限时特价</span>
                        </div>
                    </div>
                </div>

                <div className="lecture-limit-price__right flash-sale-countdown text-center">
                    <p className="flash-sale-text">距离特价结束仅剩</p>
                    <div className="time-item flash-sale-time">
                        {dd > 0 &&
                        <span className="flash-sale-time-day">{dd}天</span>
                        }
                        <span className="flash-sale-time-item">{hh}</span>
                        <span className="flash-sale-time-mh">:</span>
                        <span className="flash-sale-time-item">{mm}</span>
                        <span className="flash-sale-time-mh">:</span>
                        <span className="flash-sale-time-item">{ss}</span>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect((state) => ({
    limitMoneyExpireTimestamp: state.lecture.lecture.limit_money.expire_timestamp,
    limitMoney: state.lecture.lecture.limit_money.money,
    money: state.lecture.lecture.money,
}))(LectureLimitPrice)


// WEBPACK FOOTER //
// ./src/components/lecture/LectureLimitPrice.js